<script>
    import { createEventDispatcher } from "svelte";
    import { Accordion, AccordionItem, Button } from "@sveltestrap/sveltestrap";

    export let tableMatchRows;
    export let tableMatchsHeaders;
    export let modes;
    export let joueurs;
    export let season;

    modes = modes
        .filter((m) => {
            return tableMatchRows[m] != undefined;
        })
        .sort(function (a, b) {
            return tableMatchRows[b].length - tableMatchRows[a].length;
        });
    // modes.sort(function(a, b){
    //     return tableMatchRows[b].length - tableMatchRows[a].length
    //     })
    //     console.log(modes)

    const dispatch = createEventDispatcher();

    let dimens = "col-lg-12 col-xl-10 col-xxl-9 col-sm-12 col-md-12 col-12";

    let sortBy = {
        "Cadre 47/1": { col: 15, ascending: false },
        "Cadre 47/2": { col: 15, ascending: false },
        "Cadre 71/2": { col: 15, ascending: false },
        "Cadre 42/2": { col: 15, ascending: false },
        Libre: { col: 15, ascending: false },
        "1 Bande": { col: 15, ascending: false },
        "3 Bandes": { col: 15, ascending: false },
    };

    $: sort = (md, column) => {
        // console.log(md)
        // console.log(sortBy[md])
        if (sortBy[md].col == column) {
            sortBy[md].ascending = !sortBy[md].ascending;
        } else {
            sortBy[md].col = column;
            sortBy[md].ascending = false;
        }

        let sortModifier = sortBy[md].ascending ? 1 : -1;

        let sort = (a, b) =>
            a[column] < b[column]
                ? -1 * sortModifier
                : a[column] > b[column]
                  ? 1 * sortModifier
                  : 0;

        if (column == 7)
            tableMatchRows[md] = tableMatchRows[md].sort(function (a, b) {
                if (joueurs[a[column]] == undefined) return 0;
                if (joueurs[b[column]] == undefined) return 0;

                return (
                    joueurs[a[column]].localeCompare(joueurs[b[column]]) *
                    sortModifier
                );
            });
        else if (column == 6 || column == 11)
            tableMatchRows[md] = tableMatchRows[md].sort(function (a, b) {
                let aN = parseFloat(a[column].replace(",", "."));
                let bN = parseFloat(b[column].replace(",", "."));

                return aN < bN
                    ? -1 * sortModifier
                    : aN > bN
                      ? 1 * sortModifier
                      : 0;
            });
        else tableMatchRows[md] = tableMatchRows[md].sort(sort);
    };

    function clickAdv(l) {
        dispatch("clickAdv", {
            l,
        });
    }
</script>

<br />
<Accordion>
    {#each modes as md}
        {#if tableMatchRows[md]}
            <div class={dimens}>
                <AccordionItem class="highlight">
                    <h4 class="m-0" slot="header">
                        {md} - {season - 1}/{season} ({tableMatchRows[md].length})
                    </h4>
                    <div class="table-responsive">
                        <table
                            class="table table-sm"
                            style="border-collapse: separate;"
                        >
                            <thead>
                                <tr>
                                    {#each tableMatchsHeaders as mh, i}
                                        {#if mh == "Date"}
                                            <th
                                                on:click={sort(md, 15)}
                                                scope="col"
                                                class="table-headers">{mh}</th
                                            >
                                        {:else}
                                            <th
                                                on:click={sort(md, i)}
                                                scope="col"
                                                class="table-headers">{mh}</th
                                            >
                                        {/if}
                                    {/each}
                                </tr>
                            </thead>
                            <tbody>
                                {#each tableMatchRows[md] as m}
                                    <tr>
                                        <td class="column-center">{m[0]}</td>
                                        <td class="column-center">{m[1]}</td>
                                        {#if m[2] == "G"}
                                            <td class="column-center"
                                                ><span
                                                    class="badge"
                                                    style="background-color:red"
                                                    >G</span
                                                ></td
                                            >
                                        {:else if m[2] == "P"}
                                            <td class="column-center"
                                                ><span
                                                    class="badge"
                                                    style="background-color:blue"
                                                    >P</span
                                                ></td
                                            >
                                        {:else}
                                            <td class="column-center"
                                                ><span
                                                    class="badge"
                                                    style="background-color:lightgreen"
                                                    >N</span
                                                ></td
                                            >
                                        {/if}

                                        <td class="column-right">{m[3]}</td>
                                        <td class="column-right">{m[4]}</td>
                                        <td class="column-right">{m[5]}</td>
                                        <td class="column-right">{m[6]}</td>
                                        <td class="column-left"
                                            ><button
                                                class="border-0 butTable"
                                                on:click={() => clickAdv(m[7])}
                                                >{joueurs[m[7]]}</button
                                            ></td
                                        >
                                        <td class="column-right">{m[8]}</td>
                                        <td class="column-right">{m[9]}</td>
                                        <td class="column-right">{m[10]}</td>
                                        <td class="column-right">{m[11]}</td>

                                        <td class="column-center">{m[12]}</td>
                                        <td class="column-center">{m[13]}</td>
                                        <td class="column-center">{m[14]}</td>
                                    </tr>
                                {/each}
                            </tbody>
                        </table>
                        <!-- </div> -->
                    </div>
                </AccordionItem>
            </div>
        {/if}
    {/each}
</Accordion>

<style>
    .butTable {
        background-color: transparent;
        font-weight: bold;
        color: blue;
        text-decoration: underline;
        margin: 0px;
        padding: 0px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .highlight {
        background-color: lightsalmon !important;
        padding: 4px;
        text-align: center;
        font-size: 1.2em;
        font-weight: bold;
        border-radius: 8px;
    }
    .table-headers {
        text-align: center;
        background-color: lightgray;
        border-radius: 4px;
        border: 1px solid gray;
    }
    .column-center {
        text-align: center;
    }
    .column-right {
        text-align: end;
    }
    .column-left {
        text-align: start;
    }
    .center {
        text-align: center;
        /* display: flex; */
        /* //flex-flow: column; */
        /* justify-content: center; */
    }
</style>
